import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { UseAxios } from '../../../../../utils/UseAxios';
import { useSelector } from 'react-redux';
import { selectOACLNummber } from '../../slice/selectors';
import { commonStyle } from '../../../../../styles/theme/themes';
import { CircularProgress } from '@mui/material';
import { HistoryTable } from './HistoryTable';
import { apiList } from '../../../../../locales/apiList';

export function HistoryTab() {
  const { t } = useTranslation();
  const oacl = useSelector(selectOACLNummber);
  const [loading, setLoading] = useState<boolean>(true);
  const [historyData, setHistoryData] = useState<any[]>([]);

  React.useEffect(() => {
    const requestURL = `${apiList.getHistoryURL}${oacl}`;
    UseAxios(requestURL, 'get', null, false)
      .then(function(response) {
        setLoading(false);
        if (response.data.updateHistory) {
          setHistoryData(response.data.updateHistory);
        } else {
          setHistoryData([]);
        }
      })
      .catch(function(error) {
        console.log('error: ' + JSON.stringify(error));
      });
  }, [oacl]);

  return (
    <Wrapper>
      <div className='worklist-header'><HistoryOutlinedIcon />{t(translations.contractDetail.biHistory)}</div>
      {loading && historyData ?
        <CircularProgress />
        :
        <div>
          {historyData.length > 0 ?
            (historyData.map((item, index) =>
              <HistoryTable key={item.uuid} data={item} />,
            ))
            :
            <div className={'no-history'}>
              {t(translations.noHistoryDesc)}
            </div>
          }
        </div>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  box-shadow: ${commonStyle.boxShadow};
  border-radius: 5px;
  padding-bottom: 5px;

  .worklist-header {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    background-color: ${p => p.theme.primary};
    color: ${p => p.theme.background};
    font-size: 16px;
  }

  .no-history {
    padding: 10px 10px 5px;
  }

  .MuiTableCell-root {
    line-height: 15px;
    border-right: 1px solid rgba(224, 224, 224, 1) !important;
  }
`;
